export const CHANGE_INSTITUTION = 'CHANGE_INSTITUTION';
export const RESET_STORE = 'RESET_STORE';